import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";
import styled from "styled-components";
import {
  StyledStepNum,
  StyledTable
} from "./custom-styled-components/_MyCustomSC";
import LeftMainContent from "./left-shipping-wrapper/LeftMainContent";
import RightMainContent from "./left-shipping-wrapper/RightMainContent";
import { Radio } from "antd";
import PropTypes from 'prop-types';

const StyledRadioGroup = styled(Radio.Group)`
  margin-left: 10px;
`;

/**
 * @component
 * @category Form Page
 * @subcategory LCL/AIR Tab
 * @name LeftShippingForm
 * @description It's the LCL/AIR shipping container component
 * <br> <br>
 * **Example**
 * ```js
 *   <LeftShippingForm />
 * ```
 */
class LeftShippingForm extends Component {
  state = {};

  componentDidMount = () => this.props.updateLoadSummaryText();

  /**
   * @description when lcl/air shipping radio group is changed, this method is invoked
   * <br> <br>
   * **onRadioGroupChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | lcl/air shipping radio group onchange event |

   * Returns: Type: void
   */
  onRadioGroupChange = (e) => {
    this.props.updateLclShipppingType(e.target.value === 1 ? true : false);
    this.props.updateLoadSummaryText();
  };
  render() {
    const { isLclBoxPalletSelected } = this.props;
    return (
      <>
        <StyledTable>
          <tbody>
            <tr>
              <th>
                <StyledStepNum>1</StyledStepNum>
                <span style={{ fontWeight: 600 }}>What are you shipping?</span>
                <StyledRadioGroup
                  onChange={this.onRadioGroupChange}
                  value={isLclBoxPalletSelected ? 1 : 2}
                >
                  <Radio value={1}>Calculate by boxes/pallets</Radio>
                  <Radio value={2}>Calculate by total shipment</Radio>
                </StyledRadioGroup>
              </th>
            </tr>

            <tr>
              <td>
                {isLclBoxPalletSelected ? (
                  <LeftMainContent />
                ) : (
                  <RightMainContent />
                )}
              </td>
            </tr>
          </tbody>
        </StyledTable>
      </>
    );
  }
}


LeftShippingForm.propTypes = {
  /**
   * Whether boxes/pallets or total shipment shipping is selected on LCL mode
   */
  isLclBoxPalletSelected: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    isLclBoxPalletSelected: state.form.isLclBoxPalletSelected
  };
};

export default connect(mapStateToProps, actions)(LeftShippingForm);
